import Vue from "vue";
import FBSignInButton from "vue-facebook-signin-button";
import GoogleSignInButton from "vue-google-signin-button";
Vue.use(FBSignInButton);
Vue.use(GoogleSignInButton);
